export default "__VITE_ASSET__D3BNDH08__"